import { ActionTypes } from './action-types';
import { ISwapTrackerState } from "./state";

var initialState: ISwapTrackerState = {
    list: []
};

export const Reducer = (state: ISwapTrackerState = initialState, action: any) => {
    let s = { ...state };

    switch (action.type) {
        case ActionTypes.SET_SWAP_TRACKER_SWAPS:
            s.list = action.list;
            return s;
    }

    return state;
}